import { Link } from 'react-router-dom';
import DarkModeToggle from './DarkModeToggle';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-black dark:to-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-900 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
              <img src="/apple-touch-icon.png" alt="EightyThreeLabs" className="w-8 h-8" />
              <span className="text-xl font-semibold">
                <span className="text-brand-primary">EightyThree</span>
                <span className="text-black dark:text-white">Labs</span>
              </span>
            </Link>
            
            {/* Dark Mode Toggle */}
            <DarkModeToggle />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white dark:bg-gray-900 rounded-3xl p-12 shadow-xl">
          <Link 
            to="/" 
            className="inline-flex items-center text-brand-primary hover:text-green-700 dark:hover:text-green-400 mb-8 transition-colors"
          >
            ← Back to Home
          </Link>
          
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4 text-center">Cookie Policy</h1>
          <div className="text-center text-gray-600 dark:text-gray-400 mb-8 italic">
            Effective Date: January 1, 2025
          </div>
          
          <div className="prose max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. What Are Cookies?</h2>
              <p className="text-gray-700 dark:text-gray-300">
                Cookies are small text files that are placed on your device (computer, smartphone, or tablet) when you visit our website. They are widely used to make websites work more efficiently and provide information to website owners about user behavior and preferences.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. How We Use Cookies</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">EightyThreeLabs uses cookies and similar technologies to:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Remember your game preferences and settings</li>
                <li>Keep you logged into your account</li>
                <li>Track your game progress and statistics</li>
                <li>Analyze website usage and performance</li>
                <li>Provide personalized content and advertisements</li>
                <li>Improve our services and user experience</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. Types of Cookies We Use</h2>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300 dark:border-gray-600 mb-6">
                  <thead>
                    <tr className="bg-gray-50 dark:bg-gray-800">
                      <th className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left font-bold text-gray-900 dark:text-white">Cookie Type</th>
                      <th className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left font-bold text-gray-900 dark:text-white">Purpose</th>
                      <th className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-left font-bold text-gray-900 dark:text-white">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300"><strong>Essential Cookies</strong></td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Required for basic website functionality, user authentication, and security</td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Session/Persistent</td>
                    </tr>
                    <tr className="bg-gray-50 dark:bg-gray-800">
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300"><strong>Performance Cookies</strong></td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Collect information about website usage and performance to help us improve our services</td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Up to 2 years</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300"><strong>Functional Cookies</strong></td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Remember your preferences, game settings, and personalization choices</td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Up to 1 year</td>
                    </tr>
                    <tr className="bg-gray-50 dark:bg-gray-800">
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300"><strong>Advertising Cookies</strong></td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Used by Google AdSense and other advertising partners to serve relevant ads</td>
                      <td className="border border-gray-300 dark:border-gray-600 px-4 py-3 text-gray-700 dark:text-gray-300">Up to 2 years</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Third-Party Cookies</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">We use services from third-party companies that may place cookies on your device:</p>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">4.1 Google AdSense</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-3">We use Google AdSense to display advertisements. Google may use cookies to:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>Serve ads based on your interests and previous visits</li>
                <li>Measure ad performance and effectiveness</li>
                <li>Prevent the same ad from being shown repeatedly</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                You can learn more about Google's advertising cookies and opt-out at <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:text-green-700 dark:hover:text-green-400 transition-colors">Google Ads Settings</a>.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">4.2 Analytics Services</h3>
              <p className="text-gray-700 dark:text-gray-300">
                We may use analytics services to understand how users interact with our website. These services may use cookies to collect information about your usage patterns.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Managing Cookies</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">5.1 Browser Settings</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-3">You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>View and delete existing cookies</li>
                <li>Block all cookies</li>
                <li>Block third-party cookies</li>
                <li>Set notifications for when cookies are placed</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">5.2 Browser-Specific Instructions</h3>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies and other site data</li>
                <li><strong>Firefox:</strong> Settings → Privacy & Security → Cookies and Site Data</li>
                <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
                <li><strong>Edge:</strong> Settings → Site Permissions → Cookies and Site Data</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">6. Impact of Blocking Cookies</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-3">While you can block cookies, please note that doing so may affect your experience on our website:</p>
              <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 space-y-2">
                <li>You may need to re-enter your login credentials more frequently</li>
                <li>Your game preferences and settings may not be saved</li>
                <li>Some features may not work properly</li>
                <li>You may see less relevant advertisements</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">7. Contact Us</h2>
              <p className="text-gray-700 dark:text-gray-300">
                If you have questions about our use of cookies or this Cookie Policy, please contact us through our website at <Link to="/" className="text-brand-primary hover:text-green-700 dark:hover:text-green-400 transition-colors">eightythreelabs.com</Link>.
              </p>
            </section>
          </div>

          <hr className="my-8 border-gray-200 dark:border-gray-700" />
          
          <p className="text-center text-gray-500 dark:text-gray-400 text-sm">
            © 2025 EightyThreeLabs. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;